import React from 'react';  // import the React library
import { FaArrowLeft, FaArrowRight  } from 'react-icons/fa';
import { NavLink } from 'react-router-dom'; 

function TraversePosts(props) {
    return (
        <div>

<br />

<NavLink to={props.prevURL} style={{fontSize: '2em', marginTop: '2px', textDecoration: "none", fontWeight: "bold"}}>
<FaArrowLeft style={{color: "black"}} />
&nbsp;
<span style={{color: "black"}}>Previous Post</span>
</NavLink>

&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

<NavLink to={props.nextURL} style={{fontSize: '2em', marginTop: '2px', color: 'charcoal', textDecoration: "none", fontWeight: "bold"}}>
<span style={{color: "black"}}>Next Post</span>
&nbsp;
<FaArrowRight style={{color: "black"}} />
</NavLink>

<br />

</div>

  );
}


export default TraversePosts;